module.exports = __webpack_public_path__ + "img/city.967a2ef6.svg";